import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


const resources = {
    es: {
        translation: {
            "seo": {
                "title": "Protego Engineering | Consultoría en higiene, seguridad y medio ambiente",
                "description": "Servicios profesionales de ingeniería centrados en la higiene industrial, la seguridad en el lugar de trabajo y el impacto medioambiental. Expertos certificados al servicio del sector industrial"
            },
            home: {
                subtitle: "Servicio Profesional en Seguridad y Gestión Ambiental",
                title: "PROTEGO",
                slogan: "EL PRIMER PASO HACIA LA SEGURIDAD ES LA PREVENCIÓN",
                alt_pressure: "Medición de presión",
                alt_fire: "Capacitación contra incendios",
                alt_bg3: "Imagen de fondo 3",
                alt_bg4: "Imagen de fondo 4"
            },
            navbar: {
                home: "Inicio",
                about: "Nosotros",
                services: "Servicios",
                news: "Noticias",
                contact: "Contacto"
            },
            about: {
                title: "¿Quiénes somos?",
                description: "En Protego, somos tu socio estratégico en Seguridad, Higiene y Gestión Ambiental. Con más de 30 años de experiencia desarrollada en empresas nacionales, grandes proyectos y la asistencia a más de 200 empresas de diversos rubros, nos posicionamos como un sólido referente en la protección de tu entorno laboral y ambiental.",
                sectors_title: "Sectores",
                industrial_title: "Industrial",
                industrial_desc: "Amplia experiencia en plantas y proyectos industriales, asegurando el cumplimiento de las normativas y la prevención de riesgos laborales.",
                commercial_title: "Comercial",
                commercial_desc: "Soluciones adaptadas para el ámbito comercial, garantizando ambientes seguros, saludables y en armonía con la normativa vigente.",
                agricultural_title: "Agropecuario",
                agricultural_desc: "Programas diseñados para el sector agropecuario, considerando sus particularidades y necesidades específicas en materia de seguridad y ambiente."
            },
            services_slider: {
                title: "Nuestros Servicios",
                description: "Ofrecemos un portfolio de servicios modulares y personalizados, diseñados a medida de tus requerimientos, así como programas integrales con planificación anual que aseguran el cumplimiento normativo y fomentan una cultura de prevención en tu organización. Nuestra trayectoria y compromiso aseguran que puedas confiar en nosotros para fortalecer la seguridad y sostenibilidad de tu empresa.",
                desc_1: "Medición de espesores en recipientes sometidos a presión",
                desc_3: "Control de espesores en equipos en operación",
                desc_5: "Gestión de seguridad colectiva para trabajos en altura",
                desc_6: "Control de espesores en interior de equipos",
                desc_7: "Gestión de riesgos en minería",
                desc_8: "Medición de niveles de ruido",
                desc_9: "Gestión integral de seguridad en grandes proyectos",
                desc_10: "Sistemas integrados de gestión",
                btn_prev: "Anterior",
                btn_next: "Siguiente"
            },
            services_section: {
                title_offer: "Ofrecemos",
                btn_why: "¿Por qué es necesario?",
                btn_back: "Volver",
                key_detail: "Detalle Clave",
                cards: [
                    {
                        title: 'Recipientes a Presión',
                        description: 'Inspección y certificación de equipos sometidos a presión',
                        features: [
                            'Inspección de recipientes a presión con y sin fuego',
                            'Evaluación de pulmones de aire comprimido, amoníaco y otros gases',
                            'Control de calderas y redes de conductos a presión',
                            'Ensayos de integridad y certificación de cumplimiento legal'
                        ],
                        why: 'La inspección periódica de los recipientes a presión es crítica para prevenir fallas catastróficas y proteger la seguridad de los trabajadores. Garantiza el cumplimiento de las normativas legales vigentes, prolonga la vida útil de los equipos y asegura operaciones industriales continuas y seguras.'
                        , badge: 'Más Solicitado'
                    },

                    {
                        title: 'Inspección y Certificación',
                        description: 'Verificación técnica y certificación de equipos de izaje y maquinaria vial',
                        features: [
                            'Inspección de equipos de izaje (grúas, autoelevadores, puentes grúa, grúa pluma articulada, hidroelevadores, barquillas)',
                            'Control visual de accesorios de izaje (eslingas, grilletes, ganchos, aparejos, fajas textiles, cadenas, etc)',
                            'Control operativo de máquinas viales y de movimiento de suelos (excavadoras hidráulicas, retroexcavadoras, motoniveladoras, minipalas, etc...)',
                            'Ensayos de carga y verificación de sistemas de seguridad'
                        ],
                        why: 'La certificación garantiza la integridad estructural y operativa de los equipos, minimizando el riesgo de fallas catastróficas. Además de asegurar el cumplimiento de normativas nacionales e internacionales, protege el patrimonio de la empresa, reduce costos por paradas imprevistas y deslinda responsabilidades legales ante incidentes.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Segunda Opinión Experta',
                        description: 'Servicios remotos en todo el país: revisión independiente de su gestión de Seguridad e Higiene',
                        features: [
                            'No reemplaza al profesional actual, complementa su gestión',
                            'Revisión de Mediciones',
                            'Revisión de Planes de Acción',
                            'Revisión de Auditorías',
                            'Revisión de Inspecciones externas'
                        ],
                        why: 'Contar con una segunda mirada experta permite validar que la gestión de Seguridad e Higiene vigente sea sólida y esté correctamente fundamentada. Es especialmente valioso para Pymes, estudios jurídicos, empresas en situación de conflicto gremial y compañías de seguros que necesitan una evaluación independiente y objetiva.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Director Técnico Externo de Integridad Mecánica',
                        description: 'Servicios remotos en todo el país: seguimiento y gestión de la integridad de recipientes y equipos',
                        features: [
                            'Seguimiento de recipientes',
                            'Cronogramas de inspecciones',
                            'Priorización por criticidad',
                            'Análisis histórico',
                            'Estimación de vida útil y riesgo de falla'
                        ],
                        why: 'La gestión sistemática de la integridad mecánica reduce el riesgo de fallas catastróficas, prioriza recursos según criticidad real y anticipa el fin de vida útil de los equipos. Contar con un Director Técnico Externo permite acceder a esta expertise sin necesidad de una estructura interna dedicada.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Auditoría de Contratistas',
                        description: 'Servicios remotos en todo el país: control remoto de validación documental',
                        features: [
                            'Control remoto de validación documental (ART, Seguros, Capacitación, Aptos Médicos, Matrículas, Permisos, entre otros)',
                            'Devolución de análisis: APTO, OBSERVADO, NO APTO'
                        ],
                        why: 'La validación documental remota de contratistas permite verificar de forma ágil el cumplimiento de la normativa vigente antes del ingreso a obra u operación, reduciendo el riesgo legal y operativo asociado a documentación vencida o incompleta.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Mesa de Ayuda Técnica para Profesionales HyS',
                        description: 'Consultoría para consultores: asistencia técnica bajo abono mensual',
                        features: [
                            'Asistencia en Recipientes Sometidos a Presión',
                            'Asistencia en Interpretación Normativa',
                            'Asistencia en Investigación de accidentes',
                            'Ayuda en casos complejos'
                        ],
                        why: 'Los profesionales de Higiene y Seguridad también necesitan respaldo técnico ante casos complejos o dudas normativas. Esta mesa de ayuda ofrece una segunda opinión especializada y disponible, fortaleciendo la calidad de las decisiones sin necesidad de resolver todo en soledad.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Fractional HSE Manager',
                        description: 'Gerente de Seguridad, Higiene y Medio Ambiente externo, a tiempo parcial',
                        features: [
                            'Para empresas que no poseen o no requieren un gerente de Seguridad full time',
                            '"Alquiler" de experiencia como Director Externo de Seguridad, Higiene y Medio Ambiente',
                            'Participación en consultas y reuniones virtuales',
                            'Contribución a resolver situaciones y definir prioridades',
                            'Supervisión al referente local de HyS',
                            'Modalidad de Abono Mensual'
                        ],
                        why: 'Muchas empresas no tienen el volumen de operación que justifique un gerente de HSE de tiempo completo, pero sí necesitan una mirada estratégica y experimentada. El Fractional HSE Manager brinda ese liderazgo técnico de forma flexible y a un costo acorde a la necesidad real de la empresa.'
                        , badge: 'Más Solicitado'
                    },
                    {
                        title: 'Mediciones de Higiene en el Ambiente Laboral',
                        description: 'Evaluaciones del ambiente laboral',
                        features: [
                            'Medición de ruido e iluminación',
                            'Medición de Carga Térmica',
                            'Medición de Resistencia de Puesta a Tierra y Continuidad',
                            'Informe de verificación de instalaciones de pararrayos'
                        ],
                        why: 'El control de las condiciones laborales impacta directamente en la productividad, previenen accidentes y enfermedades laborales y son evidencia sólida de cumplimento de los requisitos legales antes las autoridades de control y terceras partes.'
                    },

                    {
                        title: 'Seguridad Laboral',
                        description: 'Gestión de riesgos en el trabajo',
                        features: [
                            'Análisis de riesgos laborales',
                            'Elaboración de registros de cumplimiento normativo a presentar ante las Aseguradoras de Riesgos del Trabajo',
                            'Preparación, ejecución y evaluación de simulacros de emergencia',
                            'Elaboración de Programas y Planes de Seguridad de Obras'
                        ],
                        why: 'El control de los riesgos laborales genera un ambiente de bienestar, protege a los trabajadores, disminuye los costos por lesiones, interrupciones y eventuales sanciones. Un plan de seguridad bien implementado es una inversión que genera tranquilidad y confianza y promueve la mejora contínua.'
                    },
                    {
                        title: 'Auditorías Técnicas',
                        description: 'Inspecciones detalladas para identificar áreas de mejora y cumplimiento normativo',
                        features: [
                            'Auditorías internas',
                            'Evaluación de riesgos de procesos',
                            'Elaboración de Plan de mejora continua'
                        ],
                        why: 'En un entorno cambiante, las auditorías ayudan a obtener un diagnóstico imparcial y preciso de la situación de la empresa en cuanto a la gestión de seguridad. Es una herramienta para detectar oportunidades de mejora, optimizar procesos y asegurar competitividad y cumplimiento regulatorio.'
                    },
                    {
                        title: 'Sistemas de Gestión',
                        description: 'Gestión Integrada de Salud, Seguridad y Medio Ambiente',
                        features: [
                            'Diseño de Sistema de Gestión según norma ISO.',
                            'Auditoría Interna de Sistema de Gestión SYSO ISO 45001:2018'
                        ],
                        why: 'Un sistema robusto integral de Salud, Seguridad y Medio Ambiente unifica la gestión, facilita el cumplimiento normativo, identifica y controla peligros, optimiza procesos, demuestra liderazgo responsable por parte de la Dirección de la empresa y favorece la mejora continua. Es cada vez más valorado como diferencial competitivo por clientes y terceras partes'
                    },
                    {
                        title: 'Capacitación',
                        description: 'Programas de formación adaptada a tu equipo de trabajo',
                        features: [
                            'Formación on line ó presencial',
                            'Armado de programa anual de capacitaciones adaptados a la actividad',
                            'Cumplimiento de contenido normativa',
                            'Generación de registros y entrega de certificados'
                        ],
                        why: 'Formar al equipo es la mejor inversión: genera y unifica información, previene riesgos, mejora la eficiencia y facilita la adaptación a nuevos desafíos. Contribuye a desarrollar una cultura de seguridad y prepara ante emergencias. Es otro pilar que evidencia el cumplimiento de los requisitos legales. La capacitación continua sostiene la seguridad, promoviendo un entorno de trabajo saludable y seguro.'
                    },
                    {
                        title: 'Consultoría Ambiental',
                        description: 'Asesoramiento especializado para implementar prácticas sostenibles',
                        features: [
                            'Análisis de impacto ambiental',
                            'Elaboración de Planes de Gestión Ambiental',
                            'Cumplimiento normativo',
                            'Gestión de Remediación de sitios impactados',
                            'Elaboración de planes de contingencia'
                        ],
                        why: 'Cuidar el ambiente es una responsabilidad empresarial: cumplir normativas y adoptar prácticas sostenibles protege el entorno, mejora la percepción de la comunidad y abre nuevas oportunidades de negocio. Los estudios preliminares permiten identificar, modificar y reducir impactos de las actividades futuras, planteando planes de acción que permitan evidenciar una gestión responsable y comprometida con el medio ambiente.'
                    },
                    {
                        title: 'Asesoramiento técnico ambiental',
                        description: 'Cumplimiento de normativas ambientales provincia de Buenos Aires (ARG)',
                        features: [
                            'Declaraciones Juradas de Residuos Especiales y Efluentes Gaseosos',
                            'Declaración Jurada Anual de Recipientes Sometidos a Presión',
                            'Medición de espesores',
                            'Memoria técnica para recipientes sometidos a presión',
                            'Categorización de Industrias',


                        ],
                        why: 'Una adecuada categorización de la industria a instalarse o ya en funcionamiento permite encuadrar la actividad anticipando los controles requeridos por la autoridad de aplicación. Es parte de la identificación de requisitos legales de cualquier sistema de gestión y documentación requerida para acceder a líneas de crédito locales o internacionales. El cumplimiento de requisitos normativos evita reclamos y sanciones.'
                    },
                    {
                        title: 'Informes Técnicos de Seguridad',
                        description: 'Seguridad de eventos y concurrencia masiva',
                        features: [
                            'Aparatos a presión',
                            'Elaboración de informe antisiniestral',
                            'Medición de puesta a tierra',
                            'Evaluación de riesgos',
                            'Capacitación al personal',
                            'Práctica de uso de matafuegos'
                        ],
                        why: 'La identificación de riesgos, el correspondiente estudio de carga de fuego, la verificación de la cantidad de elementos de extinción de incendios junto a la verificación de los sistemas de evacuación, ofrecen información importante previa a la realización de eventos de concurrencia masiva. Permite identificar brechas y tomar decisiones para estar preparados ante una contingencia. De este modo se protege a los asistentes y se evitan incidentes que puedan afectar la reputación del evento.'
                    },
                    {
                        title: 'Traducción de Textos Técnicos en Inglés',
                        description: 'Servicio de traducción técnica',
                        features: [
                            'Manuales técnicos',
                            'Consultas rápidas on line para responder correos electrónicos y elaborar presupuestos.'
                        ],
                        why: 'En un mundo global, la precisión importa. Desde complejos manuales hasta correos, presupuestos y consultas técnicas, todas requieren dominio terminológico. Un error puede causar costosos malentendidos. En un mundo dominado por la IA, la revisión humana de un profesional agrega valor y personaliza el contenido frente a clientes y proveedores.'
                    }
                ]
            },
            stats: {
                clients_top: "CLIENTES",
                clients_bottom: "SATISFECHOS",
                projects_top: "PROYECTOS",
                projects_bottom: "REALIZADOS",
                years_top: "AÑOS",
                years_bottom: "DE EXPERIENCIA" // O puedes poner "AÑOS DE" arriba y "EXPERIENCIA" abajo según prefieras
            },
            partners: {
                title: "Confían en nosotros",
                description: "Más de 200 compañías de diversos rubros vienen confiando en nuestra trayectoria y compromiso para asegurar la seguridad y sostenibilidad con un enfoque integral y personalizado para cada cliente."
            },
            contact: {
                title: "Contacto",
                options_title: "Opciones de contacto",
                email_label: "Correo Electrónico",
                owner_label: "Titular",
                whatsapp_label: "Whats App",
                location_label: "Localidad Principal",
                location_value: "Olavarría, Buenos Aires, Argentina",
                form_title: "Envianos tu consulta",
                label_subject: "Asunto",
                label_email: "Mail de contacto",
                label_message: "Consulta",
                btn_send: "Enviar",
                msg_success: "¡Mensaje enviado con éxito! Pronto nos pondremos en contacto.",
                msg_error: "Hubo un error al enviar el mensaje. Inténtalo de nuevo.",
                msg_sending: "Enviando...",
                // Mensajes prellenados para los links (opcional, pero recomendado)
                mailto_body: "Hola, estoy interesado en los servicios que vi en tu web",
                whatsapp_text: "Hola, estoy interesado en uno de los servicios que vi en su web"
            },
            news: {
                title: "Noticias",
                items: [
                    {
                        text: "PROTEGO tiene el agrado de presentar desde Estonia a nuestro nuevo partner, TEQTO, empresa líder en fabricación de instrumentos para realizar ensayos no destructivos en la industria (NDT).\n\nTEQTO ayuda a mantener los más altos estándares de calidad a empresas de rubros tales como:\n\n- Industria aeroespacial\n- Oil and Gas\n- Transporte y construcción de maquinarias\n- Power generation\n- Aviación\n- Metalurgia\n\n En esta oportunidad introducimos en Latinoamérica el medidor de profundidad de grietas ET-28.",
                        video: "teqto-partnership.mp4"
                    },
                    {
                        text: "Sumamos profesionalismo y experiencia para dar una respuesta flexible a las necesidades de la industria.\n\nPresentando nuestra propuesta de inspección de equipos y accesorios de izaje y de maquinaria vial.",
                        video: "izaje.mp4"
                    }
                ]
            }

        },

    },
    en: {
        translation: {
            "seo": {
                "title": "Protego Engineering | Hygiene, Safety & Environmental Consulting",
                "description": "Professional engineering services focused on Industrial Hygiene, Workplace Safety, and Environmental impact. Certified experts serving the industrial sector."
            },
            home: {
                subtitle: "Professional Service in Safety and Environmental Management",
                title: "PROTEGO",
                slogan: "THE FIRST STEP TOWARDS SAFETY IS PREVENTION",
                alt_pressure: "Pressure measurement",
                alt_fire: "Fire safety training",
                alt_bg3: "Background image 3",
                alt_bg4: "Background image 4"
            },
            navbar: {
                home: "Home",
                about: "About Us",
                services: "Services",
                news: "News",
                contact: "Contact"
            },
            about: {
                title: "Who are we?",
                description: "At Protego, we are your strategic partner in Safety, Hygiene, and Environmental Management in Argentina. With over 30 years of experience in national companies, major projects, and assistance to over 200 firms in various fields, we position ourselves as a solid reference in protecting your work and environmental surroundings.",
                sectors_title: "Fields",
                industrial_title: "Industrial",
                industrial_desc: "Extensive experience in industrial plants and projects, ensuring compliance with regulations and prevention of occupational risks.",
                commercial_title: "Commercial",
                commercial_desc: "Solutions adapted for the commercial sector, ensuring safe, healthy environments in harmony with current regulations.",
                agricultural_title: "Agricultural",
                agricultural_desc: "Programs designed for the agricultural sector, considering its particularities and specific needs in safety and environment."
            },
            services_slider: {
                title: "Our Services",
                description: "We offer a portfolio of modular and customized services, tailored to your requirements, as well as comprehensive programs with annual planning that ensure regulatory compliance and foster a culture of prevention in your organization. Our track record and commitment ensure that you can trust us to strengthen the safety and sustainability of your company.",
                desc_1: "Thickness measurement in pressure vessels",
                desc_3: "Thickness control in operating equipment",
                desc_5: "Collective safety management for work at heights",
                desc_6: "Internal equipment thickness control",
                desc_7: "Risk management in mining",
                desc_8: "Noise level measurement",
                desc_9: "Comprehensive safety management in large projects",
                desc_10: "Integrated management systems",
                btn_prev: "Previous",
                btn_next: "Next"
            },

            services_section: {
                title_offer: "We Offer",
                btn_why: "Why is it necessary?",
                btn_back: "Back",
                key_detail: "Key Detail",
                cards: [
                    {
                        title: 'Pressure Vessels',
                        description: 'Inspection and certification of pressurized equipment',
                        features: [
                            'Inspection of fired and unfired pressure vessels',
                            'Assessment of compressed air, ammonia, and other gas tanks',
                            'Evaluation of boilers and pressurized piping networks',
                            'Integrity testing and legal compliance certification'
                        ],
                        why: 'Regular inspection of pressure vessels is critical to prevent catastrophic failures and protect worker safety. It ensures compliance with strict legal regulations, extends the useful life of your equipment, and guarantees safe and continuous industrial operations.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Inspection and Certification',
                        description: 'Technical verification and certification of lifting equipment',
                        features: [
                            'Inspection of lifting equipment (mobile cranes, forklifts, overhead and gantry cranes, articulated boom crane, hydraulic lifts, baskets)',
                            'Visual inspection of lifting accessories (slings, shackles, hooks, hoist, textile straps, chains, etc.',
                            '‘Operational inspection of road construction and earthmoving machinery (hydraulic excavator, frontend loader, grader, etc )',
                            'Load testing and verification of safety systems'
                        ],
                        why: 'Certification ensures the structural and operational integrity of equipment, minimizing the risk of catastrophic failure. Beyond ensuring compliance with international safety standards, it protects company assets, reduces downtime costs, and mitigates legal liabilities in the event of an incident.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Second Expert Opinion',
                        description: 'Remote services nationwide: independent review of your Safety and Health management',
                        features: [
                            'Does not replace the current professional, complements their management',
                            'Review of Measurements',
                            'Review of Action Plans',
                            'Review of Audits',
                            'Review of External Inspections'
                        ],
                        why: 'Having a second expert opinion helps validate that your current Safety and Health management is solid and well-founded. It is especially valuable for SMEs, law firms, companies facing labor disputes, and insurance companies that need an independent and objective assessment.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'External Technical Director of Mechanical Integrity',
                        description: 'Remote services nationwide: monitoring and management of vessel and equipment integrity',
                        features: [
                            'Vessel monitoring',
                            'Inspection schedules',
                            'Criticality-based prioritization',
                            'Historical analysis',
                            'Useful life estimation and failure risk assessment'
                        ],
                        why: 'Systematic management of mechanical integrity reduces the risk of catastrophic failures, prioritizes resources based on real criticality, and anticipates the end of equipment useful life. Having an External Technical Director provides access to this expertise without the need for a dedicated internal structure.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Contractor Audits',
                        description: 'Remote services nationwide: remote document validation control',
                        features: [
                            'Remote control of document validation (ART, insurance, training, medical fitness certificates, licenses, permits, among others)',
                            'Analysis results: APPROVED, OBSERVED, NOT APPROVED'
                        ],
                        why: 'Remote document validation for contractors enables fast verification of regulatory compliance before entering a site or starting operations, reducing the legal and operational risk associated with expired or incomplete documentation.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Technical Help Desk for H&S Professionals',
                        description: 'Consulting for consultants: technical assistance on a monthly subscription',
                        features: [
                            'Assistance with Pressure Vessels',
                            'Assistance with Regulatory Interpretation',
                            'Assistance with Accident Investigation',
                            'Help with complex cases'
                        ],
                        why: 'Health and Safety professionals also need technical support when facing complex cases or regulatory doubts. This help desk offers a specialized, available second opinion, strengthening the quality of decisions without having to solve everything alone.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Fractional HSE Manager',
                        description: 'External part-time Health, Safety, and Environment Manager',
                        features: [
                            'For companies that do not have or do not require a full-time Safety Manager',
                            '"Rent" expertise as an External Health, Safety, and Environment Director',
                            'Participation in virtual meetings and consultations',
                            'Helps resolve situations and define priorities',
                            'Supervises the local H&S representative',
                            'Monthly subscription model'
                        ],
                        why: 'Many companies don\'t have the operational volume to justify a full-time HSE manager, but still need a strategic, experienced perspective. The Fractional HSE Manager provides that technical leadership flexibly and at a cost aligned with the company\'s actual needs.'
                        , badge: 'Most Requested'
                    },
                    {
                        title: 'Workplace Hygiene Measurements',
                        description: 'Work environment evaluations',
                        features: [
                            'Noise and lighting measurement',
                            'Thermal Load Measurement',
                            'Ground Resistance and Continuity Measurement',
                            'Verification report of lightning rod installations'
                        ],
                        why: 'Controlling working conditions directly impacts productivity, prevents accidents and occupational diseases, and is solid evidence of compliance with legal requirements before control authorities and third parties.'
                    },
                    {
                        title: 'Occupational Safety',
                        description: 'Risk management at work',
                        features: [
                            'Occupational risk analysis',
                            'Preparation of regulatory compliance records to present to Occupational Risk Insurers',
                            'Preparation, execution, and evaluation of emergency drills',
                            'Preparation of Safety Programs and Plans for Construction Sites'
                        ],
                        why: 'Controlling occupational risks generates a well-being environment, protects workers, reduces costs for injuries, interruptions, and potential sanctions. A well-implemented safety plan is an investment that generates peace of mind and trust and promotes continuous improvement.'
                    },
                    {
                        title: 'Technical Audits',
                        description: 'Detailed inspections to identify areas for improvement and regulatory compliance',
                        features: [
                            'Internal audits',
                            'Process risk assessment',
                            'Preparation of Continuous Improvement Plan'
                        ],
                        why: 'In a changing environment, audits help obtain an impartial and precise diagnosis of the company\'s situation regarding safety management. It is a tool to detect opportunities for improvement, optimize processes, and ensure competitiveness and regulatory compliance.'
                    },
                    {
                        title: 'Management Systems',
                        description: 'Integrated Health, Safety, and Environment Management',
                        features: [
                            'Management System Design according to ISO standards.',
                            'Internal Audit of SYSO ISO 45001:2018 Management System'
                        ],
                        why: 'A robust integrated Health, Safety, and Environment system unifies management, facilitates regulatory compliance, identifies and controls hazards, optimizes processes, demonstrates responsible leadership by the company\'s Management, and favors continuous improvement. It is increasingly valued as a competitive differential by clients and third parties.'
                    },
                    {
                        title: 'Training',
                        description: 'Training programs adapted to your work team',
                        features: [
                            'Online or in-person training',
                            'Preparation of annual training program adapted to the activity',
                            'Compliance with regulatory content',
                            'Generation of records and delivery of certificates'
                        ],
                        why: 'Training the team is the best investment: it generates and unifies information, prevents risks, improves efficiency, and facilitates adaptation to new challenges. It contributes to developing a safety culture and prepares for emergencies. It is another pillar that evidences compliance with legal requirements. Continuous training sustains safety, promoting a healthy and safe work environment.'
                    },
                    {
                        title: 'Environmental Impact Assesment',
                        description: 'Specialized advice to implement sustainable practices',
                        features: [
                            'Environmental impact analysis',
                            'Preparation of Environmental Management Plans',
                            'Regulatory compliance',
                            'Remediation Management of impacted sites',
                            'Preparation of contingency plans'
                        ],
                        why: 'Caring for the environment is a corporate responsibility: complying with regulations and adopting sustainable practices protects the surroundings, improves community perception, and opens new business opportunities. Preliminary studies allow identifying, modifying, and reducing impacts of future activities, proposing action plans that allow evidencing responsible management committed to the environment.'
                    },
                    {
                        title: 'Technical Environmental Advice',
                        description: 'Compliance with environmental regulations in Buenos Aires Province (ARG)',
                        features: [
                            'Affidavits for Special Waste and Gaseous Effluents',
                            'Annual Affidavit for Pressure Vessels',
                            'Industry Categorization',
                            'Affidavits of Special Waste and Gaseous Effluents',
                            'Thickness measurement and technical report for pressure vessels'
                        ],
                        why: 'Adequate categorization of the industry to be installed or already in operation allows framing the activity, anticipating controls required by the application authority. It is part of identifying legal requirements of any management system and documentation required to access local or international credit lines. Compliance with regulatory requirements avoids claims and sanctions.'
                    },
                    {
                        title: 'Technical Safety Reports',
                        description: 'Event safety and mass gatherings',
                        features: [
                            'Preparation of accident prevention report',
                            ' Grounding measurement',
                            'Risk assessment',
                            'Personnel training',
                            'Fire extinguisher use practice'
                        ],
                        why: 'Risk identification, corresponding fire load study, verification of the quantity of fire extinguishing elements along with verification of evacuation systems, offer important information prior to holding mass gathering events. It allows identifying gaps and taking decisions to be prepared for a contingency. This protects attendees and avoids incidents that could affect the event\'s reputation.'
                    },
                    {
                        title: 'Technical Text Translation',
                        description: 'Technical translation service',
                        features: [
                            'Technical manuals',

                            'Preparation of technical proposals and drafting of documents in Spanish translated by a native speaker',
                            'Quick online consultations to answer emails and prepare quote',
                        ],
                        why: 'In a global world, precision matters. From complex manuals to emails, budgets, and technical queries, all require terminological mastery. An error can cause costly misunderstandings. In a world dominated by AI, human review by a professional adds value and personalizes content for clients and suppliers.'
                    }
                ]
            },
            stats: {
                clients_top: "SATISFIED",     // Adjetivo primero
                clients_bottom: "CLIENTS",    // Sustantivo después
                projects_top: "COMPLETED",
                projects_bottom: "PROJECTS",
                years_top: "YEARS OF",
                years_bottom: "EXPERIENCE"
            },
            partners: {
                title: "Trusted by Industry Leaders", // O "Our Clients" si prefieres algo más formal
                description: "More than 200 companies from diverse sectors rely on our track record and commitment to ensure safety and sustainability with a comprehensive and personalized approach for each client."
            },
            contact: {
                title: "Contact",
                options_title: "Contact Options",
                email_label: "Email",
                owner_label: "Owner",
                whatsapp_label: "WhatsApp",
                location_label: "Main Location",
                location_value: "Olavarría, Buenos Aires, Argentina", // Nombres propios usualmente no cambian
                form_title: "Send us your inquiry",
                label_subject: "Subject",
                label_email: "Contact Email",
                label_message: "Message",
                btn_send: "Send",
                msg_success: "Message sent successfully! We will contact you soon.",
                msg_error: "There was an error sending the message. Please try again.",
                msg_sending: "Sending...",
                mailto_body: "Hello, I am interested in the services I saw on your website",
                whatsapp_text: "Hello, I am interested in one of the services I saw on your website"
            },
            news: {
                title: "News",
                items: [
                    {
                        text: "PROTEGO is pleased to present from Estonia our new partner, TEQTO, a leading company in the manufacturing of non-destructive testing (NDT) instruments in the industry.\n\nTEQTO helps maintain the highest quality standards for companies in fields such as:\n\n- Aerospace industry\n- Oil and Gas\n- Transport and machinery construction\n- Power generation\n- Aviation\n- Metallurgy\n\n\nOn this occasion, we introduce the ET-28 crack depth meter in Latin America.\n\n",
                        video: "teqto-partnership.mp4"
                    },
                    {
                        text: "We add professionalism and experience to provide a flexible response to the needs of the industry.\n\nPresenting our proposal for the inspection of lifting equipment and accessories and road machinery.",
                        video: "izaje.mp4"
                    }
                ]
            }
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'es',
        detection: {

            order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage'],
        },
        interpolation: { escapeValue: false }
    });

export default i18n;